import React, {Component} from 'react'
import './styles.scss';

class StatusMessage extends Component {
    render() {
        let className = "StatusMessage";
        if (this.props.type) {
            className += " " + this.props.type;
        } else {
            className += " info";
        }

        return (<div className={className} dangerouslySetInnerHTML={{__html:this.props.text}}/>);
    }
}

export default StatusMessage;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/StatusMessage/index.js